import TipoAbonoComponent from '@/components/cxp/tipo_abono/TipoAbonoComponent'
import TipoAbonoFormComponent from '@/components/cxp/tipo_abono/TipoAbonoFormComponent'

import TipoCargoComponent from '@/components/cxp/tipo_cargo/TipoCargoComponent'
import TipoCargoFormComponent from '@/components/cxp/tipo_cargo/TipoCargoFormComponent'

import AbonoSerieComponent from '@/components/cxp/abono_serie/AbonoSerieComponent'
import AbonoSerieFormComponent from '@/components/cxp/abono_serie/AbonoSerieFormComponent'

import AbonoComponent from '@/components/cxp/abono/AbonoComponent'
import AbonoFormComponent from '@/components/cxp/abono/AbonoFormComponent'

import CargoComponent from '@/components/cxp/cargo/CargoComponent'
import CargoVerComponent from '@/components/cxp/cargo/CargoVerComponent'
import CxpCargoFormComponent from '@/components/cxp/cargo/CxpCargoFormComponent'
import RptEstadoCuentaProveedor from '@/components/cxp/rpt_estado_cuenta_proveedor/RptEstadoCuentaProveedor'

export default [
{
    path: '/cxp/estado-cuenta-proveedor/',
    name: 'cxp-estado-cuenta-proveedor',
    component: RptEstadoCuentaProveedor,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/tipo-abono/nuevo',
    name: 'cxp-tipo-abono-nuevo',
    component: TipoAbonoFormComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/tipo-abono/editar/:id/',
    name: 'cxp-tipo-abono-editar',
    component: TipoAbonoFormComponent,
    meta: {
        requiresAuth: true,
        permission: '',
    }
},
{
    path: '/cxp/tipo-abono/',
    name: 'cxp-tipo-abono',
    component: TipoAbonoComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/tipo-cargo/nuevo',
    name: 'cxp-tipo-cargo-nuevo',
    component: TipoCargoFormComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/tipo-cargo/editar/:id/',
    name: 'cxp-tipo-cargo-editar',
    component: TipoCargoFormComponent,
    meta: {
        requiresAuth: true,
        permission: '',
    }
},
{
    path: '/cxp/tipo-cargo/',
    name: 'cxp-tipo-cargo',
    component: TipoCargoComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/abono-serie/nuevo',
    name: 'cxp-abono-serie-nuevo',
    component: AbonoSerieFormComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/abono-serie/editar/:id/',
    name: 'cxp-abono-serie-editar',
    component: AbonoSerieFormComponent,
    meta: {
        requiresAuth: true,
        permission: '',
    }
},
{
    path: '/cxp/abono-serie/',
    name: 'cxp-abono-serie',
    component: AbonoSerieComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/abono/',
    name: 'cxp-abono',
    component: AbonoComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/abono/editar/:id/',
    name: 'cxp-abono-editar',
    component: AbonoFormComponent,
    meta: {
        requiresAuth: true,
        permission: '',
    }
},
{
    path: '/cxp/abono/nuevo/',
    name: 'cxp-abono-nuevo',
    component: AbonoFormComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/cxp/cargo/',
    name: 'cxp-cargo',
    component: CargoComponent,
    meta: {
        requiresAuth: true
    }
},{
    path: '/cxp/cargo/ver/:id/',
    name: 'cxp-cargo-ver',
    component: CargoVerComponent,
    meta: {
        requiresAuth: true,
        permission: null,
    }
},{
    path: '/cxp/cargo/editar/:id/',
    name: 'cxp-cargo-editar',
    component: CxpCargoFormComponent,
    meta: {
        requiresAuth: true,
        permission: null,
    }
},
{
    path: '/cxp/cargo/nuevo/',
    name: 'cxp-cargo-nuevo',
    component: CxpCargoFormComponent,
    meta: {
        requiresAuth: true
    }
},

]